import { CapacitorPayment } from 'capacitor-payment';
import Device from '../utilities/Device';
/**
 * The native payment plugin as the card terminal — reachable on Android only,
 * where the provider apps (NLB, Payoneos, Payten APOS) run. Every other
 * platform gets `available() === false`, which is what keeps the card-read
 * confirm and the cancel-void off web, Electron and iOS.
 */
export const defaultCardTerminal = {
    available: () => Device.isAndroid(),
    initializeProvider: config => CapacitorPayment.initializeProvider(config),
    startCardRead: data => CapacitorPayment.startCardRead(data),
    closeWorkingDay: currencyCode => CapacitorPayment.closeWorkingDay({ currencyCode }),
    addListener: (eventName, listener) => CapacitorPayment.addListener(eventName, listener),
    addWorkingDayCloseListener: listener => CapacitorPayment.addListener('workingDayClosed', listener),
};
//# sourceMappingURL=DefaultCardTerminal.js.map